module.exports = __webpack_public_path__ + "img/decor-2.de30e07a.svg";